import { defineStore } from 'pinia'
import authService from '@/services/auth.service'
import { useUserStore } from './user.store'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    isAuthenticated: false,
    loading: false,
    error: null,
  }),

  getters: {
    getUser: (state) => state.user,
    isLoggedIn: (state) => state.isAuthenticated,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
  },

  actions: {
    /**
     * Login user with email and password
     */
    async login(email, password) {
      this.loading = true
      this.error = null

      try {
        const data = await authService.login(email, password)
        this.isAuthenticated = true
        this.user = { email }
        
        // Initialize user data after successful login
        const userStore = useUserStore()
        await userStore.initialize()
        
        return data
      } catch (error) {
        this.error = error.response?.data?.detail || 'Ошибка авторизации'
        throw error
      } finally {
        this.loading = false
      }
    },

    /**
     * Logout current user
     */
    logout() {
      authService.logout()
      this.user = null
      this.isAuthenticated = false
      this.error = null
      
      // Clear user store
      const userStore = useUserStore()
      userStore.clearUser()
    },

    /**
     * Request password reset
     */
    async resetPassword(email) {
      this.loading = true
      this.error = null

      try {
        const data = await authService.resetPassword(email)
        return data
      } catch (error) {
        this.error = error.response?.data?.detail || 'Ошибка отправки письма'
        throw error
      } finally {
        this.loading = false
      }
    },

    /**
     * Check if user is authenticated
     */
    checkAuth() {
      const isAuth = authService.isAuthenticated()
      this.isAuthenticated = isAuth
      if (isAuth) {
        // Load user data if authenticated
        const userStore = useUserStore()
        userStore.initialize().catch(error => {
          console.error('Error loading user data:', error)
          // If failed to load user data, logout
          this.logout()
        })
      }
    },

    /**
     * Clear error
     */
    clearError() {
      this.error = null
    },
  },
})
